export const parseTime = (time) => {
  return `${time.getHours() > 12 ? time.getHours() - 12 : time.getHours()}:${
    time.getMinutes() >= 10 ? time.getMinutes() : `0${time.getMinutes()}`
  } ${time.getHours() >= 12 ? "PM" : "AM"}`;
};
export const parse = (date) => {
  // return `${date.getMonth() +
  //   1}/${date.getDate()}/${date.getFullYear()} at ${parseTime(date)}`;
  return `${date.toLocaleString("default", {
    month: "short",
  })} ${date.getDate()}, ${date.getFullYear()} `;
};
export const parseText = (date) => {
  if ((new Date().getTime() - date.getTime()) / 1000 <= 60) {
    return "a few seconds ago";
  } else if ((new Date().getTime() - date.getTime()) / 1000 <= 3600) {
    return `${Math.floor(
      (new Date().getTime() - date.getTime()) / 1000 / 60
    )} minute${
      Math.floor((new Date().getTime() - date.getTime()) / 1000 / 60) === 1
        ? ""
        : "s"
    } ago`;
  } else if ((new Date().getTime() - date.getTime()) / 1000 <= 86400) {
    return `${Math.floor(
      (new Date().getTime() - date.getTime()) / 1000 / 3600
    )} hour${
      Math.floor((new Date().getTime() - date.getTime()) / 1000 / 3600) === 1
        ? ""
        : "s"
    } ago`;
  } else if ((new Date().getTime() - date.getTime()) / 1000 <= 604800) {
    return `${Math.floor(
      (new Date().getTime() - date.getTime()) / 1000 / 86400
    )} days ago`;
  } else if ((new Date().getTime() - date.getTime()) / 1000 <= 2592000) {
    return `${Math.floor(
      (new Date().getTime() - date.getTime()) / 1000 / 604800
    )} week${
      Math.floor((new Date().getTime() - date.getTime()) / 1000 / 604800) === 1
        ? ""
        : "s"
    } ago`;
  } else if ((new Date().getTime() - date.getTime()) / 1000 <= 31536000) {
    return `${Math.floor(
      (new Date().getTime() - date.getTime()) / 1000 / 2592000
    )} month${
      Math.floor((new Date().getTime() - date.getTime()) / 1000 / 2592000) === 1
        ? ""
        : "s"
    } ago`;
  } else {
    return `${Math.floor(
      (new Date().getTime() - date.getTime()) / 1000 / 31536000
    )} year${
      Math.floor((new Date().getTime() - date.getTime()) / 1000 / 31536000) ===
      1
        ? ""
        : "s"
    } ago`;
  }
  // if (date.getFullYear() < new Date().getFullYear()) {
  //   return `${new Date().getFullYear() - date.getFullYear()} ${
  //     new Date().getFullYear() - date.getFullYear() === 1 ? "year" : "years"
  //   } ago`;
  // } else if (date.getMonth() < new Date().getMonth()) {
  //   return `${new Date().getMonth() - date.getMonth()} ${
  //     new Date().getMonth() - date.getMonth() === 1 ? "month" : "months"
  //   } ago`;
  // } else if (date.getDate() < new Date().getDate()) {
  //   return `${new Date().getDate() - date.getDate()} ${
  //     new Date().getDate() - date.getDate() === 1 ? "day" : "days"
  //   } ago`;
  // } else if (date.getHours() < new Date().getHours()) {
  //   return `${new Date().getHours() - date.getHours()} ${
  //     new Date().getHours() - date.getHours() === 1 ? "hour" : "hours"
  //   } ago`;
  // } else if (date.getMinutes() < new Date().getMinutes()) {
  //   return `${new Date().getMinutes() - date.getMinutes()} ${
  //     new Date().getMinutes() - date.getMinutes() === 1 ? "minute" : "minutes"
  //   } ago`;
  // } else {
  //   return `A few seconds ago`;
  // }
};
export const parseNumbers = (num) => {
  if(num instanceof Array) {
    num = num.length
  }
  if (num > 1000000) {
    return `${(num / 1000000).toFixed(1)} M`;
  } else if (num > 1000) {
    return `${(num / 1000).toFixed(1)} K`;
  } else {
    return `${num}`;
  }
};
export const secondsToTime = (time) => {
  let seconds = Math.floor(time % 60);
  let minutes = Math.floor((time / 60) % 60);
  let hours = Math.floor(time / 60 / 60);
  let str = "";

  if (hours > 0) {
    str = str + `${hours}:`;
  }
  if (minutes > 0) {
    if (hours > 0) {
      if (minutes > 9) {
        str = str + `${minutes}:`;
      } else {
        str = str + `0${minutes}:`;
      }
    } else {
      str = str + `${minutes}:`;
    }
  } else {
    if (hours > 0) {
      str = str + "00:";
    } else {
      str = str + "0:";
    }
  }
  if (seconds < 10) {
    str = str + `0${seconds}`;
  } else {
    str = str + `${seconds}`;
  }

  return `${str}`;
};
export const hex2rgba = (hex, alpha = 1) => {
  try {
    const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
  } catch (e) {
    return "rgba(0,0,0,0)";
  }
};
export const parseGuid = (guid) => {
  if(!guid) {
    return ""
  }
  guid = guid.split("}")[0];
  if (guid.startsWith("{")) guid = guid.substring(1);
  return guid;
};
export const parseLive = (views) => {
  if(typeof views === "number") {
    return `${views} watching now`;
  }
  let live_watches = views.filter((item) => {
    if (
      item.end &&
      new Date().getTime() - new Date(item.end).getTime() > 30000
    ) {
      return false;
    } else {
      return true;
    }
  });
  return `${live_watches.length} watching now`;
};
export const parseSubscriptionTitle = (str) => {
  let arr = str.split(" ");
  let response = [];

  arr.forEach((s) => {
    response.push(`${s.substring(0, 1).toUpperCase()}${s.substring(1)}`);
  });

  return response.join(" ");
};

// Parses a schedule received directly from the schedule push into the format supplied by schedule.cgi
export const parseSchedule = (schedule) => {
  let report_js = {};
  let sched_js = [];
  let meta_js = {};

  let ent_array = schedule.items

  for(let item of ent_array) {
    // TODO: Find a way to be stricter about these being at the top level
    /*
    let end_ent = item.end_unix //tree(entry).children("end")[0];
    let item_ent = item.name //tree(entry).children("item")[0];
    let meta_ent = item.metadata //tree(entry).children("meta");
    let start_ent = item.start_unix //tree(entry).children("start")[0];
    */

    let sched_obj = {
      start: item.start_unix.iso8601,
      "start unix": item.start_unix.unix,
      end: item.end_unix.iso8601,
      "end unix": item.end_unix.unix,
      item: item.name,
      default: item.default
    };
    let meta_obj = {
      ...item.metadata
    };
    let guid;
    if(item.metadata.guid) {
      guid = item.metadata.guid
      sched_obj.guid = guid;
    }
    /*
    if ( !start_ent || !end_ent ||  !item_ent)
      return;

    let meta_key = not_empty_text(tree(item_ent));
    sched_obj["start"] = tree(start_ent).text();
    sched_obj["item"]  = not_empty_text(tree(item_ent));
    sched_obj["end"]   = tree(end_ent).text();

    sched_obj["end unix"]   = to_int( end_ent.attribs["unix"] );
    sched_obj["start unix"] = to_int( start_ent.attribs["unix"] );
    sched_obj["default"]    = to_func( item_ent.attribs["default"], t=>to_int(t)>0 );

    if (meta_ent) {
      // TODO: Find a way to be stricter about these being at the top level
      meta_ent.children().each((mindex, ment) => {
        let mname = ment.attribs["name"];
        let mval = tree(ment).text();

        if (empty(mval)) return;
        meta_obj[mname] = mval;
        if (mname == "guid") {
          meta_key = mval;
          sched_obj["guid"] = mval;
        }
      });
    }*/

    sched_js.push(sched_obj);
    if (guid)
      meta_js[guid] = meta_js[guid] || meta_obj;
  }

  let {reporttime, start_unix, end_unix} = schedule
  if (reporttime) {
    report_js["time"] = reporttime.time;
    report_js["unix time"] = reporttime.unix;
    report_js["gmt offset"] = parseInt(reporttime.gmt_offset_second, 10);
    report_js["timezone"] = reporttime["timezone"];
  }

  if (start_unix) {
    report_js["start time"] = start_unix.iso8601;
    report_js["start unix time"] = parseInt(start_unix.unix, 10);
  }

  if (end_unix) {
    report_js["end time"] = end_unix.iso8601;
    report_js["end unix time"] = parseInt(end_unix.unix, 10);
  }

  return {
    report: report_js,
    schedule: sched_js,
    metadata: meta_js
  };
}
